function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

export { eachAxis };
